/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetUserContactResponse
 */
export interface GetUserContactResponse {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetUserContactResponse
     */
    userId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetUserContactResponse
     */
    userContactId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetUserContactResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserContactResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserContactResponse
     */
    cellPhone: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserContactResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserContactResponse
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserContactResponse
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserContactResponse
     */
    addressLine3: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserContactResponse
     */
    fullAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserContactResponse
     */
    sendRoboDials: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserContactResponse
     */
    sendRoboTexts: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserContactResponse
     */
    sendEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserContactResponse
     */
    sendStatements: boolean;
}

/**
 * Check if a given object implements the GetUserContactResponse interface.
 */
export function instanceOfGetUserContactResponse(value: object): value is GetUserContactResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userContactId' in value) || value['userContactId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('fullAddress' in value) || value['fullAddress'] === undefined) return false;
    if (!('sendRoboDials' in value) || value['sendRoboDials'] === undefined) return false;
    if (!('sendRoboTexts' in value) || value['sendRoboTexts'] === undefined) return false;
    if (!('sendEmail' in value) || value['sendEmail'] === undefined) return false;
    if (!('sendStatements' in value) || value['sendStatements'] === undefined) return false;
    return true;
}

export function GetUserContactResponseFromJSON(json: any): GetUserContactResponse {
    return GetUserContactResponseFromJSONTyped(json, false);
}

export function GetUserContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserContactResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'userContactId': ApiUserTasksGetPageParameterFromJSON(json['userContactId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'cellPhone': json['cellPhone'],
        'email': json['email'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'fullAddress': json['fullAddress'],
        'sendRoboDials': json['sendRoboDials'],
        'sendRoboTexts': json['sendRoboTexts'],
        'sendEmail': json['sendEmail'],
        'sendStatements': json['sendStatements'],
    };
}

export function GetUserContactResponseToJSON(json: any): GetUserContactResponse {
    return GetUserContactResponseToJSONTyped(json, false);
}

export function GetUserContactResponseToJSONTyped(value?: GetUserContactResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'userContactId': ApiUserTasksGetPageParameterToJSON(value['userContactId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'cellPhone': value['cellPhone'],
        'email': value['email'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'fullAddress': value['fullAddress'],
        'sendRoboDials': value['sendRoboDials'],
        'sendRoboTexts': value['sendRoboTexts'],
        'sendEmail': value['sendEmail'],
        'sendStatements': value['sendStatements'],
    };
}

